import { FC } from 'react'

import Icon from '~/src/components/generic/PhosphorIcons/Icon'

import colors from '~/config/colorsScheme'
import { tw } from '~/lib/utils'

type Props = {
  unread: boolean
  timeSinceNotified?: string
}

const NotificationStatus: FC<Props> = ({ unread, timeSinceNotified }) => {
  return (
    <div className="flex justify-end">
      <div className="flex items-center">
        <div className={tw('text-body-s text-default', !unread && 'pr-2 font-normal')}>
          {timeSinceNotified}
        </div>

        {unread && (
          <div className="pl-3" role="read-badge">
            <span className="sr-only h-0 w-0">Unread</span>
            <Icon color={colors.red[600]} name="CircleIcon" size="8" weight="fill" />
          </div>
        )}
      </div>
    </div>
  )
}

export default NotificationStatus
